import './App.css';
import './Style.css';
import NavbarComponent from './Component/Navbar';
import { Route, Routes } from 'react-router-dom';
import Home from './Component/Home';
import Aboutus from './Component/Aboutus';
import Courses from './Component/Courses';
import Contactus from './Component/Contactus';
import ScrollToTop from './Component/ScrollToTop';
import Footer from './Component/Footer';
import Diploma from './Component/Diploma';
import Professional from './Component/Professional';
import Novschedule from './Component/Novschedule';
import Cheesecake from './Component/Cheesecake';
import Egglessbake from './Component/Egglessbake';
import Classicdessert from './Component/Classicdessert';
import Sweettarts from './Component/Sweettarts';
import Enrichbread from './Component/Enrichbread';
import Puffpastry from './Component/Puffpastry';
import DecSchedule from './Component/DecSchedule';
import Festivefavorites from './Component/Festivefavorites';
import Basicofbread from './Component/Basicofbread';
import Cookiesmacron from './Component/Cookiesmacron';
import Muffins from './Component/Muffins';
import Travelcake from './Component/Travelcake';
import Cupcakes from './Component/Cupcakes';
import Tarts from './Component/Tarts';
import Custard from './Component/Custard';
import Puffpastrian from './Component/Puffpastrian';
import Viennoiseries from './Component/Viennoiseries';
import BakeryFoundation from './Component/BakeryFoundation';
import WeekendCourse from './Component/WeekendCourse';
import MarchSchedule from './Component/MarchSchedule';
import Brownie from './Component/Brownie';
import Onecourse from './Component/Onecourse';
import Module from './Component/Module';

function App() {
  return (
    <>
    <ScrollToTop/>
    <NavbarComponent/>
    <Routes>
      <Route path='/' element={<Home/>}/>
      <Route path='/aboutus' element={<Aboutus/>}/>
      <Route path='/courses' element={<Courses/>}/>
      <Route path='/contactus' element={<Contactus/>}/>
      <Route path='/diploma' element={<Diploma/>}/>
      <Route path='/professional-bakery' element={<Professional/>}/>
     <Route path='/januaryschedule' element={<Novschedule/>}/> 
      <Route path='/cheesecake' element={<Cheesecake/>}/>
      <Route path='/egglessbake' element={<Egglessbake/>}/>
      <Route path='/travelcake' element={<Classicdessert/>}/>
      <Route path='/muffins' element={<Sweettarts/>}/>
      <Route path='/basic-of-bread' element={<Enrichbread/>}/>
      <Route path='/cookies' element={<Puffpastry/>}/>  
      <Route path='/februaryschedule' element={<DecSchedule/>}/>
      <Route path='/cupcakes' element={<Festivefavorites/>}/>
      <Route path='/meringuesandmacarons' element={<Basicofbread/>}/>
      <Route path='/puffpastry' element={<Cookiesmacron/>}/>
      <Route path='/chouxpastry' element={<Muffins/>}/>
      <Route path='/sweettarts' element={<Travelcake/>}/>
      <Route path='/viennoiseriesandenrichedbreads' element={<Cupcakes/>}/>
      <Route path='/savourybakes' element={<Tarts/>}/>
      <Route path='/custardsandclassicdesserts' element={<Custard/>}/>
      <Route path='/basicsofchocolate' element={<Puffpastrian/>}/>
      <Route path='/cakesandicing' element={<Viennoiseries/>}/>
      <Route path='/bakeryfoundationcourse' element={<BakeryFoundation/>}/>
      <Route path='/basic-to-intermediate-course' element={<WeekendCourse/>}/>
      <Route path="*" element={<Home />} /> {/* Fallback route */}
      <Route path='/marchSchedule' element={<MarchSchedule/>}/>
      <Route path='/brownie' element={<Brownie/>}/>
      <Route path='/onecourse' element={<Onecourse/>}/>
      <Route path='/customized-module' element={<Module/>}/>
    </Routes>
    <Footer/>
    </>
  );
}

export default App;
